import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function usePodcasts(data = {}) {
  const { enabled = false, configs = {} } = data;
  const { params = {} } = configs;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function getPodcasts() {
    return privateFetch.get('/v1/admin/podcasts', { params });
  }

  return useQuery(['podcasts', params], getPodcasts, {
    enabled,
    keepPreviousData: true,
  });
}

export default usePodcasts;
